<template>
  <div v-if="drawComponent">
    <div class="row" v-if="showForm">
      <div v-if='id'>
        <div :class="{'col-lg-8 col-md-10 col-sm-12': !fullWidth, 'col-sm-12': fullWidth}">
          <panel :title="formOnly ? '' : $formatter.formatUser(object)" :footerShow="editMode">
            <div slot="headingElements" v-if="!editMode && (_can('updateUser') || isMe())">
              <a class="btn btn-info mr-10" @click.prevent='setPassword'>
                <i class="icon-key"></i><span class="text-semibold">Set password</span>
              </a>
              <a class="btn btn-warning" @click.prevent='enterEditMode'>
                <i class="icon-pencil"></i><span class="text-semibold">Edit</span>
              </a>
            </div>
            <div class="row" v-show="editMode">
              <!-- div class='col-sm-12' v-if="_is('superAdmin')">
                  <div class="col-sm-6">
                      <div class="form-group" :class="{'has-error': errors.has('budget') }">
                          <label class="control-label">Agency</label>
                          <select2 name="location" v-bind:list="agencies" validate="'required'" class="form-control" :value="object.agency ? object.agency.id : null" @input="drpAgencyChanged">
                              <option disabled value="0">Select an option...</option>
                          </select2>
                      </div>
                  </div>
              </div -->
              <div class="row">
                <div class='col-sm-12'>
                  <div class="col-sm-2" style="padding-top: 16px;">
                    <div class="thumbnail" v-if="object.profile.logo">
                      <div class="thumb">
                        <a class="logo-image" :href="object.profile.logo.fullscale" data-popup="lightbox">
                          <img v-if="object.profile.logo.is_public" :src="object.profile.logo.preview" alt="logo"/>
                          <img v-if="!object.profile.logo.is_public" v-auth-img="object.profile.logo.preview" alt="logo"/>
                        </a>
                        <div class="caption-overflow">
                        <span>
                          <a href="javascript: void(0);" class="btn btn-info btn-sm" @click="removeLogo()">Remove</a>
                        </span>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <UploadForm :dropzone="true" accept="image/*" @uploadStarted="uploadStarted" @uploadComplete="uploadComplete" @uploadError="uploadError"></UploadForm>
                    </div>
                  </div>
                  <div class="col-sm-10">
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="form-group" :class="{'has-error': errors.has('location') }">
                          <label class="control-label">First name</label>
                          <input type="text" v-model="object.profile.first_name" class="form-control"/>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group" :class="{'has-error': errors.has('location') }">
                          <label class="control-label">Last name</label>
                          <input type="text" v-model="object.profile.last_name" class="form-control"/>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="form-group" :class="{'has-error': errors.has('location') }">
                          <label class="control-label">Email</label>
                          <input type="text" v-model="object.email" class="form-control"/>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group" :class="{'has-error': errors.has('location') }">
                          <label class="control-label">Phone</label>
                          <input type="text" v-model="object.profile.phone" class="form-control"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class='col-sm-12'>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group" :class="{'has-error': errors.has('location') }">
                      <label class="control-label">Date of Birth</label>
                      <input type="text" v-model="object.profile.dob" class="form-control"/>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group" :class="{'has-error': errors.has('location') }">
                      <label class="control-label">Gender</label>
                      <br/>
                      <label class="radio-inline"><input type="radio" name="gender" v-model="object.profile.gender" value="male"/> Male</label>
                      <label class="radio-inline"><input type="radio" name="gender" v-model="object.profile.gender" value="female"/> Female</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class='col-sm-12'>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group" :class="{'has-error': errors.has('location') }">
                      <label class="control-label">Address</label>
                      <input type="text" v-model="object.profile.address" class="form-control"/>
                    </div>
                  </div>
                </div>
              </div>
              <div class='col-sm-12'>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group" :class="{'has-error': errors.has('location') }">
                      <label class="control-label">Country</label>
                      <input type="text" v-model="object.profile.country" class="form-control"/>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-group" :class="{'has-error': errors.has('state') }">
                      <label class="control-label">State/Province</label>
                      <input type="text" v-model="object.profile.state" class="form-control"/>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-group" :class="{'has-error': errors.has('zip') }">
                      <label class="control-label">Postal code</label>
                      <input type="text" data-vv-scope="userForm" autocomplete="off" v-model="object.profile.zip" class="form-control"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-show="!editMode">
              <!-- div class='col-sm-12' v-if="_is('superAdmin')">
                  <div class="col-sm-6">
                      <div class="form-group" :class="{'has-error': errors.has('budget') }">
                          <label class="control-label">Agency</label>
                          <select2 name="location" v-bind:list="agencies" validate="'required'" class="form-control" :value="object.agency ? object.agency.id : null" @input="drpAgencyChanged">
                              <option disabled value="0">Select an option...</option>
                          </select2>
                      </div>
                  </div>
              </div -->
              <div class="row">
                <div class='col-sm-12'>
                  <div class="col-sm-2" style="padding-top: 16px;">
                    <div class="thumbnail" v-if="object.profile.logo">
                      <div class="thumb">
                        <a class="logo-image" :href="object.profile.logo.fullscale" data-popup="lightbox">
                          <img v-if="object.profile.logo.is_public" :src="object.profile.logo.preview" alt="logo"/>
                          <img v-if="!object.profile.logo.is_public" v-auth-img="object.profile.logo.preview" alt="logo"/>
                        </a>
                      </div>
                    </div>
                    <div class="thumbnail" v-else>
                      <div class="thumb">
                        <a class="logo-image">
                          <img :src="require('@/assets/images/placeholder.jpg')" alt="logo"/>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-10">
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="form-group" :class="{'has-error': errors.has('location') }">
                          <label class="control-label">First name</label>
                          <span class="form-control">{{object.profile.first_name}}</span>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group" :class="{'has-error': errors.has('location') }">
                          <label class="control-label">Last name</label>
                          <span class="form-control">{{object.profile.last_name}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="form-group" :class="{'has-error': errors.has('location') }">
                          <label class="control-label">Email</label>
                          <span class="form-control">{{object.email}}</span>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group" :class="{'has-error': errors.has('location') }">
                          <label class="control-label">Phone</label>
                          <span class="form-control">{{object.profile.phone}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class='col-sm-12'>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group" :class="{'has-error': errors.has('location') }">
                      <label class="control-label">Date of Birth</label>
                      <span class="form-control">{{object.profile.dob}}</span>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group" :class="{'has-error': errors.has('location') }">
                      <label class="control-label">Gender</label>
                      <br/>
                      <label class="radio-inline"><input type="radio" readonly name="gender" v-model="object.profile.gender" value="male"/> Male</label>
                      <label class="radio-inline"><input type="radio" readonly name="gender" v-model="object.profile.gender" value="female"/> Female</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class='col-sm-12'>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group" :class="{'has-error': errors.has('location') }">
                      <label class="control-label">Address</label>
                      <span class="form-control">{{object.profile.address}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class='col-sm-12'>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group" :class="{'has-error': errors.has('location') }">
                      <label class="control-label">Country</label>
                      <span class="form-control">{{object.profile.country}}</span>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-group" :class="{'has-error': errors.has('location') }">
                      <label class="control-label">State/Province</label>
                      <span class="form-control">{{object.profile.state}}</span>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-group" :class="{'has-error': errors.has('location') }">
                      <label class="control-label">Postal code</label>
                      <span class="form-control">{{object.profile.zip}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div slot="footerElements" v-if="editMode && !formOnly">
              <div class="pull-right">
                <button @click.prevent="cancelEditMode" class="btn btn-link legitRipple">Cancel</button>
                <button type="submit" @click.prevent="saveData()" :disabled="errors.any('userForm')" class="btn btn-primary legitRipple">Save changes</button>
              </div>
            </div>
          </panel>
        </div>
      </div>
      <div v-else>
        <div :class="{'col-lg-8 col-md-10 col-sm-12': !fullWidth, 'col-sm-12': fullWidth}">
          <panel id="vizpan" :title='"New prospect"' :footerShow="true">
            <div class="row" id="visrow">
              <div class='col-sm-12' v-if="_is('superAdmin')">
                <div class="col-sm-6">
                  <div class="form-group" :class="{'has-error': errors.has('budget') }">
                    <label class="control-label">Agency</label>
                    <select2 name="location" v-bind:list="agencies" validate="'required'" class="form-control" :value="object.agency ? object.agency.id : null" @input="drpAgencyChanged">
                      <option disabled value="0">Select an option...</option>
                    </select2>
                  </div>
                </div>
              </div>
              <div class='col-sm-12'>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group" :class="{'has-error': errors.has('location') }">
                      <label class="control-label">First name</label>
                      <input type="text" v-model="object.first_name" class="form-control"/>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group" :class="{'has-error': errors.has('location') }">
                      <label class="control-label">Last name</label>
                      <input type="text" v-model="object.last_name" class="form-control"/>
                    </div>
                  </div>
                </div>
              </div>
              <div class='col-sm-12'>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group" :class="{'has-error': errors.has('location') }">
                      <label class="control-label">Email</label>
                      <input type="text" v-model="object.email" class="form-control"/>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group" :class="{'has-error': errors.has('location') }">
                      <label class="control-label">Phone</label>
                      <input type="text" v-model="object.phone" class="form-control"/>
                    </div>
                  </div>
                </div>
              </div>
              <div class='col-sm-12'>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group" :class="{'has-error': errors.has('location') }">
                      <label class="control-label">Date of Birth</label>
                      <input type="text" v-model="object.dob" class="form-control"/>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group" :class="{'has-error': errors.has('location') }">
                      <label class="control-label">Gender</label>
                      <br/>
                      <label class="radio-inline"><input type="radio" v-model="object.gender" value="male"/> Male</label>
                      <label class="radio-inline"><input type="radio" v-model="object.gender" value="female"/> Female</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class='col-sm-12'>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group" :class="{'has-error': errors.has('location') }">
                      <label class="control-label">Address</label>
                      <input type="text" v-model="object.address" class="form-control"/>
                    </div>
                  </div>
                </div>
              </div>
              <div class='col-sm-12'>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group" :class="{'has-error': errors.has('location') }">
                      <label class="control-label">Country</label>
                      <input type="text" v-model="object.country" class="form-control"/>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-group" :class="{'has-error': errors.has('location') }">
                      <label class="control-label">State/Province</label>
                      <input type="text" v-model="object.state" class="form-control"/>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-group" :class="{'has-error': errors.has('location') }">
                      <label class="control-label">Postal code</label>
                      <input type="text" v-model="object.zip" class="form-control"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div slot="footerElements">
              <div class="pull-right">
                <router-link tag="button" :to="{name: 'users'}" class="btn btn-link legitRipple">Cancel</router-link>
                <button type="submit" @click.prevent="saveData()" :disabled="errors.any('userForm')" class="btn btn-primary legitRipple">Save changes</button>
              </div>
            </div>
          </panel>
        </div>
      </div>
    </div>
    <modal id="setUserPassword" :size="'sm'" v-show="setPasswordMode">
      <div slot="header">
        <button type="button" class="close" @click.prevent="setPasswordClose()">×</button>
        <h5 class="modal-title">Set new password</h5>
      </div>
      <div slot="body">
        <div class="row">
          <div class='col-sm-12'>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group" :class="{'has-error': errors.has('passwordForm.Password') }">
                  <input type="password" v-model="np.np" data-vv-scope="passwordForm" data-vv-name="Password" data-vv v-validate="{required: true, is: np.cp, min: 6}" placeholder="New password" class="form-control" :title="errors.first('Password')"/>
                  <div class="form-control-feedback" v-if="errors.has('passwordForm.Password')">
                    <i class="icon-cancel-circle2"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class='col-sm-12'>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group" :class="{'has-error': errors.has('passwordForm.Confirmation') }">
                  <input type="password" v-model="np.cp" data-vv-scope="passwordForm" data-vv-name="Confirmation" v-validate="{required: true, min: 6}" placeholder="Repeat password" class="form-control" :title="errors.first('Confirmation')"/>
                  <div class="form-control-feedback" v-if="errors.has('passwordForm.Confirmation')">
                    <i class="icon-cancel-circle2"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <button type="button" @click.prevent="setPasswordClose" class="btn btn-default legitRipple">Cancel</button>
        <button type="submit" @click.prevent="setPasswordApply" :disabled="errors.any('passwordForm')" class="btn btn-primary legitRipple" v-show="setPasswordMode">Save changes</button>
      </div>
    </modal>
  </div>
</template>

<script>
import Vue from 'vue'

import UserService from '@/services/user.service'
import AgencyService from '@/services/agency.service'

import UploadForm from '@/components/_partial/UploadForm'
import Panel from '@/components/_partial/_atomic/panel'
import Select2 from '@/components/_partial/_atomic/Select2'
import Modal from '@/components/Modal'

export default {
  name: 'UserForm',
  components: {
    Panel,
    Select2,
    UploadForm,
    Modal
  },

  props: {
    'entity': {
      type: Object
    },
    'oid': {
      type: [String, Number]
    },
    'fullWidth': {
      type: Boolean,
      default: false
    },
    'formOnly': {
      type: Boolean,
      default: false
    },
    'editModeInitial': {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      id: null,
      object: {},
      idFilter: [],
      currentObject: false,
      localizedFormat: {},
      /** service **/
      service: UserService,
      agencyService: new AgencyService(),
      statuses: [],
      systemStatuses: [],
      groupStatuses: [],
      showForm: false,
      mode: {
        statusMap: {},
        apartmentStatusMap: {},
        resetAfterMount: false,
        disabled: false
      },
      np: {

      },
      /** **/
      agencies: [],
      /** **/
      editMode: false,
      setPasswordMode: false,
      /** **/
      hasChanges: false,
      savingChanges: false,
      drawComponent: true
    }
  },

  computed: {},

  beforeMount () {
    this.localizedFormat = Vue.config.localizedFormat
    if (this.mode.resetAfterMount) {
      this.reset(true)
    }
    this.mode.statusMap = Vue.config.statusMap
    this.systemStatuses = Vue.config.statuses
    this.groupStatuses = Vue.config.statusGroups['user'] ? Vue.config.statusGroups['user'] : Vue.config.statusGroups['*']
    this.statuses = []
    for (let i = 0; i < this.groupStatuses.length; i++) {
      this.statuses.push(this.systemStatuses[this.groupStatuses[i]])
    }
    if (this.oid) {
      if (this.$route.name === 'users.profile') {
        if (parseInt(this.oid) !== parseInt(this.$store.getters.userId)) {
          this.$router.replace('/')
        }
      }
      this.id = this.oid
    }
  },

  watch: {
    '$route': 'flushObjectIfRequired'
  },

  mounted () {
    if (this.editModeInitial) {
      this.editMode = true
      if (this.oid) {
        this.id = this.oid
      }
      if (this.entity) {
        this.id = this.entity.id
      }
    }
    this.agencyService.getList({}, result => {
      console.log(result)
      this.agencies = []
      result.forEach((i, ind) => {
        this.agencies.push({
          id: i.id,
          text: i.name
        })
      })
    }, err => {
      console.log('Err: ', err)
    })
    this.reset(true)
    this.refresh()
    this.mode.resetAfterMount = false
  },

  methods: {
    isMe () {
      return parseInt(this.id) === parseInt(this.$store.getters.userId)
    },

    drpAgencyChanged (val) {
      if (this.object.hasOwnProperty('agency_id')) {
        this.object.agency_id = val
      }
      if (this.object.hasOwnProperty('agency')) {
        if (this.object.agency !== null && this.object.agency.hasOwnProperty('id')) {
          this.object.agency.id = val
        } else {
          this.object.agency = val
        }
      }
    },

    flushObjectIfRequired () {
      console.log(this.$route)
      if (this.$route.name === 'users.create') {
        this.id = false
        this.mode.resetAfterMount = true
        // this.object = {}
        for (let i in this.service.__itemTemplate) {
          this.object[i] = this.service.__itemTemplate[i]
        }
        this.$emit('resetObject', this.object)
        this.mode.resetAfterMount = false
        this.hardReset()
      } else {
        if (this.oid) {
          if (this.$route.name === 'users.profile') {
            if (parseInt(this.oid) !== parseInt(this.$store.getters.userId)) {
              this.$router.replace('/')
            }
          }
          this.service.item(this.oid, result => {
            for (let i in result) {
              if (result.hasOwnProperty(i)) {
                this.object[i] = result[i]
              }
            }
            this.id = this.object.id
            this.$emit('loadObject', this.object)
            this.showForm = true
            this.$emit('shown', this.object)
            this.hardReset()
          })
        }
      }
    },

    hardReset () {
      let vm = this
      vm.drawComponent = false
      Vue.nextTick(() => {
        vm.drawComponent = true
        this.makeIdFilter()
        this.object = this.object
      })
    },

    reset (forceItemReset = true) {
      this.hasChanges = false
      if (typeof this.entity === 'object' && this.entity.hasOwnProperty('id')) {
        for (let i in this.entity) {
          if (this.entity.hasOwnProperty(i)) {
            this.object[i] = this.entity[i]
            if (i === 'profile') {
              this.object = Object.assign(this.object, { 'first_name': this.entity[i].first_name })
              this.object = Object.assign(this.object, { 'last_name': this.entity[i].last_name })
            }
          }
        }
        this.id = this.entity.id
        forceItemReset = false
      }
      this.$emit('reset', forceItemReset)
      if (forceItemReset) {
        this.flushObjectIfRequired()
        this.$emit('resetObject', this.object)
        this.mode.resetAfterMount = false
      }
      this.makeIdFilter()
    },

    refresh (newInstance) {
      if (!this.object.id && this.oid) {
        this.service.item(this.oid, result => {
          for (let i in result) {
            if (result.hasOwnProperty(i)) {
              this.object[i] = result[i]
              if (i === 'profile') {
                this.object.first_name = result[i].first_name
                this.object.last_name = result[i].last_name
              }
            }
          }
          this.id = this.object.id
          this.$emit('loadObject', this.object)
          this.showForm = true
          this.$emit('shown', this.object)
          this.hardReset()
        })
      } else {
        if (newInstance) {
          for (let i in newInstance) {
            if (newInstance.hasOwnProperty(i)) {
              this.object[i] = newInstance[i]
              if (i === 'profile') {
                this.object.first_name = this.newInstance[i].first_name
                this.object.last_name = this.newInstance[i].last_name
              }
            }
          }
          this.id = this.object.id
          this.$emit('assignObject', this.object)
          this.showForm = true
          this.$emit('shown', this.object)
          this.hardReset()
        }
        this.showForm = true
        this.$emit('shown', this.object)
      }
      if (this.object.hasOwnProperty('id')) {
        this.id = this.object.id
      }
      this.makeIdFilter()
    },

    removeLogo () {
      this.object.profile.logo = null
      this.object.profile.logo_image_id = null
      this.$forceUpdate()
    },

    setLogo (image) {
      this.object.profile = Object.assign(this.object.profile, {
        logo: image || null
      })
      this.object.profile.logo_image_id = image.id || null
      this.$forceUpdate()
    },

    uploadComplete (file) {
      this.mode.disabled = false
      this.$logger.log('uploadComplete', file)
      this.setLogo(file.uploaded.image || null)
    },

    uploadStarted (file) {
      this.$logger.log('uploadStarted', file)
      this.mode.disabled = true
    },

    uploadError (file) {
      this.mode.disabled = false
      this.$logger.log('uploadError', file)
      this.$popup.warning('Failed to upload file')
    },

    saveData () {
      if (this.mode.disabled) {
        return
      }
      if (this.id) {
        this.service.update(this.id, this.prepareData(this.object), result => {
          if (this.editMode) {
            this.editMode = false
          }
          this.refresh()
          this.$emit('updated')
        })
      } else {
        this.service.create(this.prepareData(this.object), result => {
          for (let i in result) {
            if (result.hasOwnProperty(i)) {
              this.object[i] = result[i]
            }
          }
          this.$emit('created')
          if (!this.formOnly) {
            this.$router.push('/configuration/users/details/' + parseInt(this.object.id))
          }
        })
      }
    },

    enterEditMode () {
      this.editMode = true
      this.showForm = false
      this.showForm = true
    },

    cancelEditMode () {
      this.editMode = false
      this.showForm = false
      this.showForm = true
    },

    saveChanges () {
      if (this.hasChanges) {
        /* this.savingChanges = true
                  this.object.purchaseOrderProducts.forEach(item => {
                    promises.push(PoProductService.update(this.id, item.id, item))
                  })
                  Promise.all(promises).then(() => {
                    this.savingChanges = false
                    this.hasChanges = false
                    this.reset()
                  }) */
      }
    },

    checkChanges (e) {
      this.hasChanges = true
    },

    prepareData (obj) {
      // let result = Object.assign({}, obj)
      // result.is_public = result.is_public ? 1 : 0
      let result = null
      let agencyId = obj.agency !== null ? (typeof obj.agency === 'object' ? obj.agency.id : obj.agency) : null
      if (obj.id) {
        result = {
          id: obj.id,
          first_name: obj.profile.first_name,
          last_name: obj.profile.last_name,
          email: obj.email,
          agency_id: agencyId,
          isIndividual: true,
          dob: obj.profile.dob,
          zip: obj.profile.zip,
          address: obj.profile.address,
          country: obj.profile.country,
          city: obj.profile.city,
          phone: obj.profile.phone,
          gender: obj.profile.gender,
          state: obj.profile.state,
          logo_image_id: obj.profile.logo_image_id
        }
      } else {
        result = {
          first_name: obj.first_name,
          last_name: obj.last_name,
          email: obj.email,
          agency_id: agencyId,
          dob: obj.dob,
          zip: obj.zip,
          address: obj.address,
          country: obj.country,
          phone: obj.phone,
          gender: obj.gender,
          state: obj.state
        }
      }
      return result
    },

    canBeChanged () {
      return true
      // let result = typeof this.object === 'object'
      // result = result && this.object.status === 1
      // return result
    },

    setPassword () {
      this.setPasswordMode = true
    },

    setPasswordClose () {
      this.setPasswordMode = false
      this.np = {}
    },

    setPasswordApply () {
      this.$validator.validateAll().then(() => {
        this.service.setPassword(this.id, this.np, (result) => {
          this.$popup.success('Password has been changed')
          this.setPasswordClose()
          this.np = {}
          this.$emit('item:changed', true)
        })
      })
    },

    /** **/

    formatPrice (value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },

    makeIdFilter () {
      this.idFilter = []
      if (this.object && Array.isArray(this.object.purchaseOrderProducts)) {
        for (let i in this.object.purchaseOrderProducts) {
          this.idFilter.push(this.object.purchaseOrderProducts[i].product_id)
        }
      }
    }

    /** action methods **/
    /** sub-action methods **/
  },
  beforeDestroy () {
    this.object = {}
  }
}
</script>

<style scoped>
.logo-image img {
  max-height: 112px;
  min-height: 112px;
  max-width: 100%;
  width: auto;
}
span.form-control {
  overflow: hidden;
}
</style>
